import { FaRegCalendar, FaMapMarkerAlt, FaRegClock } from 'react-icons/fa';

import FilledImage from 'src/components/molecules/FilledImage';
import DateStamp from 'src/components/atoms/DateStamp';
import BoxTitle from 'src/components/atoms/BoxTitle';
import BoxHighlight from 'src/components/atoms/BottomRightBoxHighlight';
import EventCardTags from 'src/components/molecules/EventCardTags';
import AdaptiveEventImage from "../../molecules/AdaptiveEventImage"

const BoxItem = ({ event, horizontal, imageLoading }) => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow">
        <div className="absolute top-2 z-10">
          <DateStamp event={event} />
        </div>
        <div className="absolute top-1 z-10 right-0">
          <EventCardTags event={event} count={1} />
        </div>
        {event.imageUrl && (
          <AdaptiveEventImage
            src={event.imageUrl}
            alt={event.title}
            containerHeightClass="h-40"
            loading={imageLoading}
          />
        )}
        <div className="w-full h-auto">
          <div className={`mx-2 mt-2 text-base ${horizontal ? 'h-10' : ''}`}>
            <h3 className="font-bold line-clamp-2 leading-5">{event.title}</h3>
          </div>

          <div className="flex flex-row text-xs m-2 text-gray-600">
            <div className="flex-grow line-clamp-1">
              <FaMapMarkerAlt className="inline-block -mt-0.5" /> {event.venueName}
            </div>
            <div className="flex-initial ml-2  whitespace-nowrap">
              {event.isOnNow && event.multiDay && (
                <>
                  <FaRegCalendar className="inline-block  -mt-0.5" /> To {event.endDateDesc}
                </>
              )}
              {!(event.isOnNow && event.multiDay) && (
                <>
                  <FaRegClock className="inline-block  -mt-0.5" /> {event.timeDesc}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxItem;
